<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {copyObject} from "../lib/lib";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import LocationTransferPrices from "./LocationTransferPrices.svelte";

    export let location;
    export let all_locations;
    export let onClose = () => {
    };

    const vehicles = Object.fromEntries( // map vehicle types
        $app.vehicle_types.map(({id, type}) => [id, type])
    );

    let locations = copyObject(all_locations);
    let is_dirty = false;
    let loaded = false;

    const onPriceChange = () => {
        is_dirty = true;
    }

    const initialize = () => {
        // init vehicles in locations
        locations = locations.filter(x => x.id != location.id);
        locations.map(item => {
            item.prices = {};
            $app.vehicle_types.map(vehicle => {
                item.prices[vehicle.id] = null;
            });
        });

        load();
    }

    const load = () => {
        const onSuccess = result => {
            result.map(price => {
                let locationItem = null;
                if (price.location_id == location.id) {
                    locationItem = locations.find(x => x.id == price.destination_id);
                } else {
                    locationItem = locations.find(x => x.id == price.location_id);
                }
                if (locationItem) {
                    locationItem.prices[price.vehicle_type_id] = price.price;
                }
            });
            locations = locations;

            loaded = true;
        }

        const onFailure = err => {
        };

        R.handle(R.location.loadLocationPrices, location.id, onSuccess, onFailure, LOADER.POPUP);
    }

    export const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Prices saved!");
            is_dirty = false;
        }

        const onFailure = err => {
        };

        let data = [];
        locations.map(item => {
            Object.keys(item.prices).map(vehicle_type_id => {
                let price = Number(item.prices[vehicle_type_id]);
                if (price > 0) {
                    data.push({
                        location_id: location.id,
                        destination_id: item.id,
                        vehicle_type_id,
                        price,
                    });
                }
            });
        });

        R.handle(R.location.editLocationPrice, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = ()=> {
        if (is_dirty) {
            Alert.confirm("Location prices", "You have made changes to the prices for this location.\nExit without saving?", () => {
                onClose();
            });
            return;
        }

        onClose();
    }

    initialize();
</script>
{#if loaded}
    <div class="panel panel-default">
        <div class="panel-heading">
            <div class="text-dark">Prices from <b>{location.name}</b></div>
            <button class="btn-reset panel-close px-2" on:click={close}>
                &times;
            </button>
        </div>
        <div class="panel-body panel-pad">
            {#each locations as location}
                <LocationTransferPrices bind:location {vehicles} onChange={onPriceChange}/>
            {/each}
        </div>
    </div>
{/if}